import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';

import { AuthState } from '@app/core/auth/store/auth.state';

import { API_SKIP_TOKEN_INTERCEPTOR_HEADER } from '../tokens/api-skip-token-interceptor.header';

export function apiTokenInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const store = inject(Store);
  const token = store.selectSnapshot(AuthState.accessToken);

  if (!token || !!req.headers.get('authorization')) {
    return next(req);
  }

  if (req.headers.has(API_SKIP_TOKEN_INTERCEPTOR_HEADER)) {
    const headers = req.headers.delete(API_SKIP_TOKEN_INTERCEPTOR_HEADER);
    return next(req.clone({ headers }));
  }

  return next(
    req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    }),
  );
}
